var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 105.49 105.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .command-cls-1 {\n        fill: #39fdc1;\n      }\n\n      .command-cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Command_Button_Slider",
    "data-name": "Command Button Slider"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "command-cls-1",
    cx: 52.74,
    cy: 52.74,
    r: 52.74
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "command-cls-2",
    points: "84.77 48.97 63.2 36.92 66.17 46.29 84 58.13 64.04 71.39 52.74 88.82 41.45 71.39 21.49 58.13 39.32 46.29 42.29 36.92 20.72 48.97 6.13 48.97 52.74 93.44 99.36 48.97 84.77 48.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "command-cls-2",
    points: "60.65 67.23 74.6 57.96 62.13 49.67 52.74 20.07 43.35 49.67 30.89 57.96 44.84 67.23 52.74 79.42 60.65 67.23"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommand);
export default __webpack_public_path__ + "static/media/Command.02acb8faa6a9cad791ecd8ab0972898d.svg";
export { ForwardRef as ReactComponent };